import React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import OutboxFilters from './OutboxFilters';
import OutboxRow from './OutboxRow';
import PaginationFooter from '../../components/PaginationFooter';

const HEADERS = [
  { label: 'Agendado para', align: 'left' },
  { label: 'Empresa', align: 'left' },
  { label: 'Tipo', align: 'left' },
  { label: 'Telefone', align: 'left' },
  { label: 'Status', align: 'left' },
  { label: 'Tentativas', align: 'left' },
  { label: 'Último erro', align: 'left' },
  { label: 'Referência', align: 'left' },
];

/**
 * OutboxTable - Filtros, tabela e paginação server-side da fila de WhatsApp (Admin Geral)
 * @param {Object} props
 * @param {Array} props.rows
 * @param {boolean} props.isLoading
 * @param {string|null} props.error
 * @param {Object} props.pagination
 * @param {Object} props.filters - props repassadas ao OutboxFilters
 * @param {boolean} props.late - recorte de atrasadas ligado
 * @param {Function} props.onPageChange
 */
function OutboxTable({
  rows = [],
  isLoading = false,
  error = null,
  pagination,
  filters,
  late = false,
  onPageChange,
}) {
  const hasActiveFilters = Boolean(
    late
    || filters?.companyInput
    || filters?.automationType
    || filters?.messageKind
    || filters?.priority
    || filters?.dateFrom
    || filters?.dateTo
  );

  return (
    <Paper
      sx={{
        borderRadius: '12px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        border: '1px solid #E8ECF0',
        overflow: 'hidden',
      }}
    >
      <OutboxFilters {...filters} />

      {error && (
        <Alert severity="error" sx={{ borderRadius: 0 }}>
          {error}
        </Alert>
      )}

      <TableContainer sx={{ boxShadow: 'none', borderRadius: 0 }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ bgcolor: '#F8F9FC' }}>
              {HEADERS.map((h) => (
                <TableCell
                  key={h.label}
                  align={h.align}
                  sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.8125rem', whiteSpace: 'nowrap' }}
                >
                  {h.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={HEADERS.length} align="center" sx={{ py: 6 }}>
                  <CircularProgress size={32} />
                </TableCell>
              </TableRow>
            ) : rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={HEADERS.length} align="center" sx={{ py: 6 }}>
                  <Typography variant="body2" color="text.secondary">
                    {hasActiveFilters ? 'Nenhuma mensagem com esses filtros' : 'Nenhuma mensagem na fila'}
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row) => (
                <OutboxRow key={row.id} row={row} />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <PaginationFooter pagination={pagination} onPageChange={onPageChange} itemLabel="mensagens" />
    </Paper>
  );
}

export default OutboxTable;
